export default "__VITE_ASSET__DupMkY6q__ 500w";